import { StyleSheet, Text, View } from "react-native";

import {
  fonts,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";
import { AppText } from "./AppText";
import { Card } from "./Card";
import { ProgressBar } from "./ProgressBar";

/** Headline metric: big value, supporting label, and a completion bar. */
export function StatMeter({
  label,
  value,
  caption,
  tone = "primary",
}: {
  label: string;
  /** 0..1 — drives both the displayed percentage and the bar. */
  value: number;
  caption?: string;
  tone?: "primary" | "danger";
}) {
  const stylesheet = useThemedStyles(makeStyles);
  const clamped = Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0));

  return (
    <Card gap="sm">
      <AppText size="xs" tone="muted" weight="medium">
        {label}
      </AppText>
      <View style={stylesheet.valueRow}>
        <Text style={stylesheet.value}>{Math.round(clamped * 100)}</Text>
        <Text style={stylesheet.unit}>%</Text>
      </View>
      <ProgressBar value={clamped} tone={tone} height={8} />
      {caption ? (
        <AppText size="xs" tone="muted">
          {caption}
        </AppText>
      ) : null}
    </Card>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    valueRow: {
      flexDirection: "row",
      alignItems: "baseline",
      gap: spacing.xs,
      marginBottom: spacing.xs,
    },
    value: {
      color: colors.heading,
      fontFamily: fonts.display,
      fontSize: 40,
      lineHeight: 42,
    },
    unit: {
      color: colors.mutedForeground,
      fontFamily: fonts.displaySemibold,
      fontSize: 18,
      lineHeight: 20,
    },
  });
